type Occupation = {
  id: string | null;
  name: string;
  subOccupationId?: string | null;
  subOccupation?: Occupation;
};

const createOccupationStructure = (
  cbo: models.CategoryCbo | null,
  subOccupation: models.SubCategoryCbo | null,
  grandchild: models.SubCategoryCbo | null,
  greatGrandson: models.SubCategoryCbo | null,
  greatGreatFinish: models.cboOccupations | null
): Occupation => {
  const result: Occupation = {
    id: cbo?.id ?? null,
    name: cbo?.name ?? '',
  };

  if (subOccupation) {
    result.subOccupation = {
      id: subOccupation.id,
      name: subOccupation.name,
      subOccupationId: cbo?.id ?? null,
    };

    if (grandchild) {
      result.subOccupation.subOccupation = {
        id: grandchild.id,
        name: grandchild.name,
        subOccupationId: grandchild?.subOccupationId ?? null,
      };

      if (greatGrandson) {
        result.subOccupation.subOccupation.subOccupation = {
          id: greatGrandson.id,
          name: greatGrandson.name,
          subOccupationId: greatGrandson?.subOccupationId ?? null,
        };

        if (greatGreatFinish) {
          result.subOccupation.subOccupation.subOccupation.subOccupation = {
            id: greatGreatFinish.id,
            name: greatGreatFinish.name,
            subOccupationId: greatGreatFinish?.subOccupationId ?? null,
          };
        }
      }
    }
  }

  return result;
};

export default createOccupationStructure;
